var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 63 63",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:3px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m55.099 26.581a23.842 24.682 0 0 0-47.394 3.6144",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m31.519 54.849a23.851 24.692 0 0 0 21.928-14.989s1.867-0.84079 1.867-4.6195",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m25.992 55.032c0 2.0391 2.0257 3.6917 4.5275 3.6917 2.5018 0 4.5368-1.6526 4.5368-3.6917 0-2.0391-2.0257-3.6917-4.5368-3.6917-2.5111 0-4.5275 1.6526-4.5275 3.6917z",
    fill: "currentColor",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m11.42 24.097h2.6885a3.734 3.8657 0 0 1 3.734 3.8657v7.8667a3.734 3.8657 0 0 1-3.734 3.8657h-2.6885a3.734 3.8657 0 0 1-3.734-3.8657v-7.8667a3.734 3.8657 0 0 1 3.734-3.8657z",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m54.38 38.429a3.734 3.8657 0 0 1-2.8005 1.266h-2.6605a3.734 3.8657 0 0 1-3.734-3.8657v-7.8667a3.734 3.8657 0 0 1 3.734-3.8657h2.6605a3.734 3.8657 0 0 1 3.734 3.8657v7.8667a3.734 3.8657 0 0 1-0.9335 2.5997z",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.f550ed062124d30b0baa34e5bd9b345a.svg";
export { ForwardRef as ReactComponent };